import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import titleize from 'titleize'
import humanizeString from 'humanize-string'
import KEYCODE from 'keycode'
import { withRouter } from 'react-router-dom'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import { parseLocation } from '../../../common/utils/urlHelper'
import FiltersSingleSelectPanel from './filtersPanel/singleSelect'
import { reportOpenSearchFilterPanel } from '../../../common/analytics/filtersAnalytics'
import FolderIcon from '../icons/folder'
import ArrowFillRightIcon from '../icons/arrowFillRight'
import RightOpenIcon from '../icons/rightOpen'

class FiltersCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Category')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  /**
   * because the result returned from api does include the top and sub category
   * we have to filter them and only keep the one that needs to be displayed in the UI
   */
  filterOption(items, chosenCategory) {
    return items.filter((item, idx) => {
      return (
        item.key.indexOf(chosenCategory) > -1 && item.key !== chosenCategory
      )
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, location, categoryRootCount } = this.props
    const parsedLocation = parseLocation(location)

    const chosenCategory = parsedLocation.category || ''
    const chosenCategoryArray = chosenCategory.split('/')
    const chosenCategoryLength = chosenCategoryArray.length
    const filteredCategoryItems = this.filterOption(items, chosenCategory)

    const renderChosenCategory = () => {
      let categoriesInBox
      // show the top level categories if there's no selected category
      if (chosenCategory === '') {
        categoriesInBox = (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {titleize(humanizeString(item.key))}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
        // if there's a chosen category, show the breadcrumb menu
      } else {
        const getChosenCategoryDisplayName = chosenCategory => {
          return chosenCategoryArray.map((categoryName, index) => {
            const isLast = index === chosenCategoryLength - 1
            return (
              <div key={index} className="search-facet-panel__status-title">
                {titleize(humanizeString(categoryName))}
                {!isLast && (
                  <ArrowFillRightIcon
                    width="10"
                    height="15"
                    className="search-facet-panel__status-icon"
                  />
                )}
              </div>
            )
          })
        }
        categoriesInBox = (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              {getChosenCategoryDisplayName(chosenCategory)}
            </div>
          </div>
        )
      }
      return categoriesInBox
    }

    const panelHeaderClassNames = classNames(
      'search-facet-panel__header--start',
      {
        'is-active': showPanel
      }
    )

    // TODO: fix animation for showing and hiding the panel
    // and possibly merge `OnKeyDown` and `ClickOutside` component
    return (
      <div className="search-facet--no-margin" id="category-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <FolderIcon /> Category
            <span style={{ float: 'right' }}>
              <RightOpenIcon />
            </span>
          </h2>
          {renderChosenCategory()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersSingleSelectPanel
                rootCount={categoryRootCount}
                showPanel={showPanel}
                items={filteredCategoryItems}
                parsedLocation={parsedLocation}
                togglePanel={this.togglePanel}
                breadcrumbsLabel="categories"
                type="category"
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersCategory.propTypes = {
  items: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  categoryRootCount: PropTypes.number.isRequired
}

export const FiltersCategoryComponent = FiltersCategory
export default withRouter(FiltersCategory)



// WEBPACK FOOTER //
// ./client/components/filters/filtersCategory.js